import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "subscription-item__left" }
const _hoisted_2 = { class: "subscription-item__center" }
const _hoisted_3 = { class: "subscription-item__center__name" }
const _hoisted_4 = { class: "subscription-item__center__price" }
const _hoisted_5 = {
  key: 0,
  class: "subscription-item__right"
}

import Subscription from "@/ts/User/Types/Subscription";
import YellowRadioButton from "@/components/FormInput/YellowRadioButton.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'SubscriptionItem',
  props: /*@__PURE__*/_mergeModels({
    id: {},
    name: {},
    price: {},
    discount: {},
    isDefault: { type: Boolean },
    durationInMonths: {}
  }, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any) {

const props = __props
const [model] = _useModel(__props, "modelValue")
const onClick = () => {
  model.value = props.id;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "subscription-item",
    onClick: onClick
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(YellowRadioButton, {
        modelValue: _unref(model),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(model) ? (model).value = $event : null)),
        value: _ctx.id
      }, null, 8, ["modelValue", "value"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.name), 1),
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.price.toLocaleString('ru-RU')) + " руб.", 1)
    ]),
    (_ctx.discount > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, "-" + _toDisplayString(_ctx.discount) + "%", 1))
      : _createCommentVNode("", true)
  ]))
}
}

})